import Vue from "vue";

const premiumPaywallHub = new Vue();

export default {
    data() {
        return {
            premiumPaywallHub: premiumPaywallHub,
        };
    },
    methods: {
        $premiumPaywall({ variant = "premium", daysRemaining = 10, onSubscribe, onClose } = {}) {
            this.premiumPaywallHub.$off("subscribe");
            this.premiumPaywallHub.$off("close");

            if (onSubscribe) {
                this.premiumPaywallHub.$on("subscribe", (payload) => {
                    onSubscribe(payload);
                });
            }

            if (onClose) {
                this.premiumPaywallHub.$on("close", () => {
                    onClose();
                    this.premiumPaywallHub.$off("subscribe");
                    this.premiumPaywallHub.$off("close");
                });
            }

            this.premiumPaywallHub.$emit("open", {
                variant,
                daysRemaining,
            });
        },
        $premiumPaywallDone() {
            this.premiumPaywallHub.$emit("done");
            this.premiumPaywallHub.$off("subscribe");
            this.premiumPaywallHub.$off("close");
        },
        $premiumPaywallSubscribe(payload = {}) {
            const product = payload.storeItem;

            // Outside the native shell, or without a matched store product (e.g. outdated app),
            // prompt the user to install/update from the app stores.
            if (!window.nsWebViewInterface || !product) {
                this.premiumPaywallHub.$emit("requireStoreUpdate");

                return;
            }

            const userId = this.$store.state.user ? this.$store.state.user.id : null;

            const onCantSubscribe = () => {
                window.nsWebViewInterface.off("cantsubscribe", onCantSubscribe);
                window.nsWebViewInterface.off("subscribedToApp", onSubscribed);
                this.premiumPaywallHub.$emit(
                    "error",
                    "We couldn't complete your subscription. Please try again.",
                );
            };

            const onSubscribed = () => {
                window.nsWebViewInterface.off("cantsubscribe", onCantSubscribe);
                window.nsWebViewInterface.off("subscribedToApp", onSubscribed);
                // Refetch the user so has_premium reflects server truth before closing the paywall.
                this.$store.dispatch("getUser");
                this.$premiumPaywallDone();
            };

            window.nsWebViewInterface.on("cantsubscribe", onCantSubscribe);
            window.nsWebViewInterface.on("subscribedToApp", onSubscribed);

            window.nsWebViewInterface.emit("subscribeToProduct", {
                product,
                user_id: userId,
            });
        },
    },
};
